var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmpty4 = function SvgEmpty4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 708,
    height: 200,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4B466",
    d: "M402.348 0h-107.93a8.3 8.3 0 0 0-8.302 8.302v107.93a8.3 8.3 0 0 0 8.302 8.302h107.93a8.3 8.3 0 0 0 8.302-8.302V8.302A8.3 8.3 0 0 0 402.348 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7CD99",
    d: "M402.348 0h-53.965v124.534h53.965a8.3 8.3 0 0 0 8.302-8.302V8.302A8.3 8.3 0 0 0 402.348 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC8200",
    d: "M311.023 43.587a6.227 6.227 0 0 0 12.453 0V37.36h6.227a6.227 6.227 0 1 0 0-12.453h-6.227V18.68a6.227 6.227 0 1 0-12.453 0v6.227h-6.227a6.227 6.227 0 1 0 0 12.453h6.227zM366.307 35.539a6.228 6.228 0 0 0 8.806 8.806l4.402-4.402 4.403 4.403a6.227 6.227 0 0 0 8.806-8.806l-4.403-4.403 4.404-4.404a6.226 6.226 0 1 0-8.806-8.806l-4.404 4.404-4.403-4.403a6.226 6.226 0 1 0-8.805 8.806l4.402 4.403z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC8200",
    fillRule: "evenodd",
    d: "M335.93 93.4a6.227 6.227 0 0 1-6.227 6.227h-24.907a6.227 6.227 0 1 1 0-12.453h24.907a6.227 6.227 0 0 1 6.227 6.227",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC8200",
    d: "M391.97 89.25a6.227 6.227 0 1 0 0-12.454h-24.907a6.226 6.226 0 0 0-6.226 6.227 6.226 6.226 0 0 0 6.226 6.227zM391.97 110.005a6.227 6.227 0 0 0 0-12.453h-24.907a6.226 6.226 0 0 0 0 12.453z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "empty_4_svg__a",
    width: 117,
    height: 144,
    x: 228,
    y: 39,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3E0F0",
    d: "M322.438 182.65h17.854a3.94 3.94 0 0 0 3.94-3.94V97.736a3.94 3.94 0 0 0-1.149-2.781l-54.179-54.36a3.94 3.94 0 0 0-5.581 0l-54.174 54.36a3.94 3.94 0 0 0-1.149 2.78v80.975a3.94 3.94 0 0 0 3.94 3.94h17.853"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#empty_4_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5C080",
    d: "M322.438 182.65h21.794V96.107l-58.119-58.313L228 96.107v86.543h21.793"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2A84D",
    d: "m228 96.107 58.113-58.313.003 144.856H228z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2A84D",
    d: "M300.892 120.536h-14.775v62.113h16.745v-60.143a1.97 1.97 0 0 0-1.97-1.97"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE8F1A",
    d: "M286.116 120.536H271.34a1.97 1.97 0 0 0-1.97 1.97v60.143h16.746z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#80CCE5",
    d: "M400.925 183.158a2.807 2.807 0 0 1 2.807-2.807h72.981a2.807 2.807 0 0 1 2.807 2.807v8.421a2.807 2.807 0 0 1-2.807 2.807h-72.981a2.807 2.807 0 0 1-2.807-2.807zM407.942 155.089a2.807 2.807 0 0 1 2.807-2.807h67.367a2.807 2.807 0 0 1 2.807 2.807v8.42a2.807 2.807 0 0 1-2.807 2.807h-67.367a2.807 2.807 0 0 1-2.807-2.807z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#66C2E0",
    d: "M419.17 169.123a2.807 2.807 0 0 1 2.807-2.807h50.525a2.807 2.807 0 0 1 2.807 2.807v8.421a2.806 2.806 0 0 1-2.807 2.807h-50.525a2.807 2.807 0 0 1-2.807-2.807z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#99D6EB",
    d: "M440.222 180.351h36.491a2.807 2.807 0 0 1 2.807 2.807v8.421a2.807 2.807 0 0 1-2.807 2.807h-36.491zM444.433 152.282h33.683a2.807 2.807 0 0 1 2.807 2.807v8.42a2.807 2.807 0 0 1-2.807 2.807h-33.683z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#80CCE5",
    d: "M447.24 166.316h25.262a2.807 2.807 0 0 1 2.807 2.807v8.421a2.806 2.806 0 0 1-2.807 2.807H447.24zM437.27 157.896c0 20.848-16.901 37.748-37.749 37.748s-37.748-16.9-37.748-37.748c0-20.849 16.9-37.749 37.748-37.749s37.749 16.9 37.749 37.749"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#66C2E0",
    d: "M361.773 157.896c0 20.848 16.9 37.748 37.748 37.748v-75.497c-20.848 0-37.748 16.9-37.748 37.749"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#99D6EB",
    fillRule: "evenodd",
    d: "M399.521 124.502c-19.378 0-33.393 14.016-33.393 33.394s14.015 33.393 33.393 33.393 33.393-14.015 33.393-33.393-14.015-33.394-33.393-33.394m-42.104 33.394c0-23.254 18.851-42.105 42.104-42.105 23.254 0 42.105 18.851 42.105 42.105S422.775 200 399.521 200s-42.104-18.851-42.104-42.104",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#80CCE5",
    d: "M399.521 124.502c-19.378 0-33.393 14.016-33.393 33.394s14.015 33.393 33.393 33.393V200c-23.253 0-42.104-18.851-42.104-42.104 0-23.254 18.851-42.105 42.104-42.105z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#09C",
    d: "M410.585 146.985c-6.063-6.037-15.899-6.037-21.962 0q-.527.526-.993 1.086h10.44a4.21 4.21 0 0 1 0 8.421h-13.923c-.091.999-.085 2.004.019 3.002h13.904a4.21 4.21 0 0 1 0 8.421h-10.276q.394.458.829.891c6.063 6.037 15.899 6.037 21.962 0a4.212 4.212 0 0 1 5.942 5.967c-9.348 9.309-24.498 9.309-33.846 0a23.8 23.8 0 0 1-4.813-6.858h-3.028a4.211 4.211 0 0 1 0-8.421h.876q-.1-1.501-.013-3.002h-.863a4.21 4.21 0 1 1 0-8.421h2.939a23.8 23.8 0 0 1 4.902-7.053c9.348-9.309 24.498-9.309 33.846 0a4.212 4.212 0 0 1-5.942 5.967"
  })));
};
export default SvgEmpty4;